<template>
  <div>
    <div class="row1">
      <div>
        <el-button
          @click="onAdd"
          class="row-btn add"
          type="primary"
          size="small"
          >新增报备</el-button
        >
        <el-button
          @click="onDel"
          class="row-btn del"
          type="primary"
          size="small"
          >删除</el-button
        >
      </div>
      <div class="dis-flex">
        <el-input
          size="small"
          clearable
          placeholder="搜索品牌名称"
          prefix-icon="el-icon-search"
          v-model="searchVal"
        >
        </el-input>
        <el-button
          @click="onSearch"
          class="row-btn add search"
          type="primary"
          size="small"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="tab-box">
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column label="序号" width="55" align="center">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌名称"> </el-table-column>
        <el-table-column prop="name" label="客户名称"> </el-table-column>
        <el-table-column prop="principal" label="报备人"> </el-table-column>
        <!-- <el-table-column prop="name" label="部门"> </el-table-column> -->
        <el-table-column prop="industry" label="行业"> </el-table-column>
        <!-- <el-table-column prop="phone" label="联系方式"> </el-table-column> -->
        <el-table-column prop="address" label="地址"> </el-table-column>
        <!-- <el-table-column prop="name" label="标志项"> </el-table-column> -->
        <el-table-column prop="create_time" label="报备时间"> </el-table-column>
        <el-table-column prop="expire_time" label="到期时间"> </el-table-column>
        <el-table-column prop="remind_time" label="到期提醒日"> </el-table-column>
        <el-table-column prop="track" label="跟单情况"> </el-table-column>
        <el-table-column prop="status" label="合作情况"> </el-table-column>
		<el-table-column prop="audit_status" label="审核状态"> </el-table-column>
		
        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <div class="handle-box">
              <span class="txt-btn txtC" @click="handleEdit(scope.row)"
                >修改</span
              >
			  <span class="txt-btn txtC" @click="handleDelay(scope.row)"
			    >延长报备</span
			  >
			  <span v-show="scope.row.editExpireTime_button" class="txt-btn txtC" @click="handleDate(scope.row)"
			    >修改到期时间</span
			  >
			  <span v-show="scope.row.audit_button" class="txt-btn txtC" @click="handleExamine(scope.row)"
			    >延长审核</span
			  >
              <!-- <span class="txt-btn del-txt" @click="handleDel(scope.row)"
                >删除</span
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box">
        <el-pagination
		 v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<examine ref="examineDialog" @examine="onExamine"></examine>
	<dialog-date ref="dateDialog" @date="onDate"></dialog-date>
  </div>
</template>

<script>
	import examine from '../../components/dialog/reportExamine.vue'
	import dialogDate from '../../components/dialog/reportDate.vue'
export default {
	components:{
		examine,
		dialogDate
	},
  data() {
    return {
		id:'',
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
	  // console.log(this.$route);
	  this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
	  onDate(e){
		  this.$api2.editExpireTime(e).then((res)=>{
			  if(res.code == 1){
				  this.getList()
				  this.$refs.dateDialog.dialogVisible = false;
				  this.$message.success(res.msg)
			  }else{
				  this.$message.error(res.msg)
			  }
		  })
	  },
	  handleDate(v){
		  this.$refs.dateDialog.ruleForm.id = v.id
		  this.$refs.dateDialog.ruleForm.expire_time = v.expire_time
		  this.$refs.dateDialog.dialogVisible = true;
	  },
	  // 审核接口
	  onExamine(e){
		  this.$api2.reportAudit(e).then((res)=>{
			  if(res.code == 1){
				  this.getList()
				  this.$refs.examineDialog.dialogVisible = false;
				  this.$message.success(res.msg)
			  }else{
				  this.$message.error(res.msg)
			  }
		  })
	  },
	  // 审核弹框
	  handleExamine(v){
		  this.$refs.examineDialog.ruleForm.id = v.id
		  this.$refs.examineDialog.ruleForm.status = '1'
		  this.$refs.examineDialog.dialogVisible = true;
	  },
	  // 延长报备
	  handleDelay(v){
		  this.$confirm('确认延长报备？', '提示').then(() => {
		  	 this.$api2.reportDelay({id:v.id}).then((res)=>{
		  	 	if(res.code == 1){
		  	 		this.$message.success(res.msg)
		  	 		this.getList()
		  	 	}else{
		  	 		this.$message.error(res.msg)
		  	 	}
		  	 })
		  }).catch(()=>{})
	  },
    //搜索
    onSearch(){
		this.pageObj.page = 1
		this.pageObj.filter.brand = this.searchVal;
		// this.pageObj.filter.name = this.searchVal;
		this.pageObj.op.brand = '%*%'
		// this.pageObj.op.name = '%*%'
		this.getList()
    },
	
    // 添加
    onAdd() {
        this.$router.push({ path: "/addReport",query: {type: 1} });
    },
	//修改
	handleEdit(v){
		v.type = 2
		this.$router.push({ path: "/addReport",query: v });
	},
	// 删除
	handleDel(v){
		this.$confirm('确认删除：'+v.brand+' ？', '提示').then(() => {
			 this.$api2.deleteReport({id:v.id}).then((res)=>{
			 	if(res.code == 1){
			 		this.$message.success(res.msg)
			 		this.getList()
			 	}else{
			 		this.$message.error(res.msg)
			 	}
			 })
		}).catch(()=>{})
	},
    //多选删除
    onDel() {
      if (!this.multipleSelection.length) return this.$message.error("请勾选要删除的选项！");
	  let ids = []
	  this.multipleSelection.forEach((v,k)=>{
	  	ids[k] = v.id
	  })
	  this.$confirm('确认删除？', '提示').then(() => {
	  	this.$api2.deleteReport({id:ids}).then((res)=>{
	  		if(res.code == 1){
	  			this.$message.success(res.msg)
	  			this.getList()
	  		}else{
	  			this.$message.error(res.msg)
	  		}
	  	})
	  }).catch(()=>{})
	  
    },
    // 获取数据列表
    getList() {
		this.loading = true;
		//审批，关联信息跳转过来筛选数据
		if(this.id){
			this.pageObj.filter.id = this.id
			this.pageObj.op.id = '='
		}else{
			delete this.pageObj.id
		}
      this.$api2.reportList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
			this.total = res.count;
			this.tableData = res.data;
			// //审批，关联信息跳转过来筛选数据
			// if(this.id){
			// 	this.total = 1
			// 	res.data.forEach((v,k)=>{
			// 		if(v.id == this.id){
			// 			this.tableData = [v]
			// 		}
			// 	})
			// }else{
			// 	this.total = res.count;
			// 	this.tableData = res.data;
			// }
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-between;
	.txt-btn{
		margin: 5px 0;
	}
}
</style>